import { EntityUpgradesList, ResourceCost, UpgradeType } from '../../types/game-types';
import { costToBuyNItems } from '../helpers/calculate-cost';
import { trySpendResources } from '../helpers/try-spend-resources';

/**
 * Pure: spends currencies via `trySpendResources` and returns the next `upgrades` map, or `null` if purchase failed.
 * Used by `useUpgradesStore` (Zustand) — no React reducer state.
 */
export function applyBuyUpgradeIfAffordable(
  upgrades: EntityUpgradesList,
  upgradeId: UpgradeType,
  /** e.g. `click`, `warrior`, `catapult` — matches keys on `EntityUpgradesList`. */
  entityType: string,
): EntityUpgradesList | null {
  const currentUpgrade = upgrades[entityType][upgradeId];

  const currencies = Object.keys(currentUpgrade.cost) as (keyof ResourceCost)[];

  const purchaseCost = currencies.reduce((costObj, currency) => {
    costObj[currency] = costToBuyNItems(
      currentUpgrade.cost[currency]!,
      currentUpgrade.costGrowthRate,
      currentUpgrade.purchased,
      1,
    );
    return costObj;
  }, {} as ResourceCost);

  if (!trySpendResources(purchaseCost)) {
    return null;
  }

  const nextUpgrade = {
    ...currentUpgrade,
    purchased: currentUpgrade.purchased + 1,
    multiplier: currentUpgrade.multiplier + currentUpgrade.bonusPerOwned * 1,
  };

  return {
    ...upgrades,
    [entityType]: {
      ...upgrades[entityType],
      [upgradeId]: nextUpgrade,
    },
  };
}
